import { UserAuth, UserContextType } from "app/context/AuthContext";
import { useState } from "react";
import { toast } from "react-toastify";

export const useSecurity = () => {
  const { updateUserPassword, reauthenticateUser } =
    UserAuth() as UserContextType;
  const [formValues, setFormValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    if (formValues.newPassword !== formValues.confirmPassword) {
      setIsLoading(false);
      return toast.error("Passwords do not match");
    }

    try {
      await reauthenticateUser(formValues.currentPassword);
      await updateUserPassword(formValues.newPassword);
      setFormValues((prevState)=>({...prevState,currentPassword: "",
        newPassword: "",
        confirmPassword: ""}))
      setIsChangingPassword(false)
      toast.success("Password updated successfully");
    } catch (e: any) {
      console.log(e);
      if (e.code === "auth/wrong-password") {
        setIsLoading(false);
        return toast.error("Wrong password");
      }
      toast.error("An error occurred. Please try again");
    } finally {
      setIsLoading(false);
    }
  };

  const onFormChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const allFieldsFilled = Object.values(formValues).every(
    (value) => value.trim() !== ""
  );

  return { onFormChange, allFieldsFilled, onSubmit, isLoading ,formValues,isChangingPassword,
    setIsChangingPassword};
};
